var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import { Row } from "react-bootstrap";
import { get } from "lodash";
import { brand, greys } from "@irati/ui/src/global/colors";
import isColorLight from "@irati/ui/src/global/isColorLight";
import Button from "@irati/ui/src/Button";
import { H2 } from "@irati/ui/src/Typography";
import { FormattedMessage } from "@irati/utils/lang";
import padding from "@irati/ui/src/global/padding";
import Flex from "@irati/ui/src/Flex";
var PageHeader = styled(Row)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), padding.large);
var Pill = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  background-color: ", ";\n  border-radius: 15px;\n  color: ", ";\n  font-size: 12px;\n  margin-left: ", ";\n  margin-top: 18px;\n  padding: 2px 10px;\n  position: relative;\n"], ["\n  display: inline-block;\n  background-color: ", ";\n  border-radius: 15px;\n  color: ", ";\n  font-size: 12px;\n  margin-left: ", ";\n  margin-top: 18px;\n  padding: 2px 10px;\n  position: relative;\n"])), function (props) { return get(props, "color") || brand.default; }, function (props) { return (isColorLight(get(props, "color") || brand.default) ? greys.black : greys.white); }, function (_a) {
    var theme = _a.theme;
    return theme.spacing.one;
});
var DescWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  clear: both;\n  margin-top: ", ";\n"], ["\n  clear: both;\n  margin-top: ", ";\n"])), padding.base);
var StyledH2 = styled(H2)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: inline-block;\n  word-break: break-word;\n"], ["\n  display: inline-block;\n  word-break: break-word;\n"])));
var CompanyValuesTitle = /** @class */ (function (_super) {
    __extends(CompanyValuesTitle, _super);
    function CompanyValuesTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CompanyValuesTitle.prototype.render = function () {
        var _a = this.props, count = _a.count, onClick = _a.onClick;
        return (React.createElement(PageHeader, null,
            React.createElement(Flex, { justifyContent: "space-between", alignItems: "center" },
                React.createElement(Flex, { alignItems: "flex-start" },
                    React.createElement(StyledH2, null,
                        React.createElement(FormattedMessage, { id: "admin.companyValues.list.header" })),
                    React.createElement(Pill, null,
                        React.createElement(FormattedMessage, { id: "admin.companyValues.list.headerCount", values: { count: count } }))),
                React.createElement(Button, { onClick: onClick, primary: true },
                    React.createElement(FormattedMessage, { id: "admin.companyValues.list.add" }))),
            React.createElement(DescWrapper, null,
                React.createElement(FormattedMessage, { id: "admin.companyValues.list.desc" }))));
    };
    return CompanyValuesTitle;
}(PureComponent));
export default CompanyValuesTitle;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
